import { Avatar, Box, Button, Grid, Modal, Rating, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import Sidebar from "./Sidebar";
import axios from 'axios';
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { StarBorderOutlined } from "@mui/icons-material";
import { formatDistanceToNowStrict } from "date-fns";
export default function Reviews() {

    var url = `http://localhost:${process.env?.PORT || 3000}/`

    var loc = useLocation();

    const shopId = loc.pathname.split("/")[2].split("-").pop();

    useEffect(() => {
        console.log(shopId);
    }, [shopId])

    const [reviews, setreviews] = useState([]);

    async function fetchReviews() {
        if (!shopId) {
            return;
        }
        const result = await axios.post(url + 'salon/review/fetch', {
            ShopId: shopId
        });
        var data = result.data
        if (data.response == 'failed') {
            alert(data.reason);
        } else {
            setreviews(data.results);
            console.log(data.results);
        }
    }
    useEffect(() => {
        fetchReviews();
    }, [shopId])

    const [showModal, setShowModal] = useState(false);
    const [ModalData, setModalData] = useState(null);
    return (
        <>


            <Grid container height={'100vh'} className='admin-Section' width={'100%'}>
                <Sidebar />
                <Grid height={'100%'} p={3} container alignItems={'center'} justifyContent={'center'} size={{ xs: 9.6 }}>
                    <TableContainer sx={{ background: '#0F1536', color: 'white', borderRadius: 2 }}>
                        <Table aria-label="caption table">
                            {/* <caption>A basic table example with a caption</caption> */}
                            <TableHead>
                                <TableRow>
                                    <TableCell className="text-white">Name</TableCell>
                                    <TableCell className="text-white">Rating</TableCell>
                                    <TableCell align="center" className="text-white">Review</TableCell>
                                    <TableCell align="center" className="text-white">Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {reviews.map((row, index) => (
                                    <>
                                        <TableRow key={index}>
                                            <TableCell className="text-white" component="th" scope="row">
                                                {row.User.FirstName}
                                            </TableCell>
                                            <TableCell className="text-white">
                                                <Rating readOnly emptyIcon={
                                                    <StarBorderOutlined sx={{ color: "white" }} />
                                                } value={row.Rating} />

                                            </TableCell>
                                            {/* <TableCell className="text-white">{row.Review}</TableCell> */}
                                            {/* <TableCell className="text-white">{row.Reason}</TableCell> */}
                                            <TableCell align="center" className="text-white">
                                                <button onClick={() => {
                                                    setShowModal(true);
                                                    setModalData(row);
                                                }} className="btn-outline-white text-white">View Review</button>
                                            </TableCell>
                                            <TableCell align="center" className="text-white">
                                                <button className=" btn-outline-white text-white">Reply</button>
                                            </TableCell>
                                        </TableRow >
                                    </>
                                ))}
                            </TableBody>
                            <Modal className="modal-cont" onClose={() => setShowModal(false)} open={showModal}>
                                <Box className='modall'>
                                    <Grid container justifyContent={'space-between'} alignItems={'center'}>
                                        <Grid container size={{ lg: 7 }} alignItems={'center'}>
                                            <Avatar
                                                alt="Remy Sharp"
                                                src="https://b.zmtcdn.com/data/user_profile_pictures/51e/b1004de7ed3df4783159544aa850c51e.jpg?fit=around%7C100%3A100&crop=100%3A100%3B%2A%2C%2A"
                                                sx={{ width: 50, height: 50, border: '1px solid black' }}
                                                variant="rounded"
                                            />
                                            <Typography pl={1.5} py={0} lineHeight={1} variant="h6" fontWeight={'bold'} >Jhon Doe</Typography>
                                        </Grid>
                                        <Rating readOnly name="half-rating" value={ModalData?.Rating} precision={0.5} />
                                        {/* <Grid size={{lg:5}}> */}

                                        {/* </Grid> */}
                                    </Grid>
                                    <Typography mt={3} variant="body1" className="text-secondary">{ModalData?.Review}</Typography>
                                    <Grid container justifyContent={'end'} mt={1}>
                                        {/* {formatDistanceToNow(row.CreatedAt)} ago */}
                                        {ModalData?.CreatedAt && (
                                            formatDistanceToNowStrict(
                                                new Date(ModalData?.CreatedAt),
                                                { addSuffix: true }
                                            )
                                        )}
                                    </Grid>
                                    <Grid container className='mt-3' justifyContent={'space-between'}>
                                        <Grid size={{ lg: 5.5 }}>
                                            <Button onClick={() => setShowModal(false)} variant="contained" fullWidth>
                                                <Typography variant="body1">Cancel</Typography>
                                            </Button>
                                        </Grid>
                                        <Grid size={{ lg: 5.5 }}>
                                            <Button type="submit" variant="outlined" fullWidth>
                                                <Typography variant="body1">Reply</Typography>
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Modal>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid >


        </>
    )

}